import React, { useState } from 'react';
import styled from 'styled-components';
import { colors } from '../styles/GlobalStyles';
import { rv, containerWidth, mediaQueries } from '../styles/responsive';
import { LayersIcon } from './ui/Icons';
import TermsModal from './TermsModal';

const FooterSection = styled.footer`
  width: 100%;
  padding: ${rv(64, 40)} ${rv(24, 20)} ${rv(40, 24)};
  background: ${colors.slate[50]};
  border-top: 1px solid ${colors.slate[200]};
`;

const FooterContainer = styled.div`
  max-width: ${containerWidth(1280, 24)};
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: ${rv(32, 24)};

  ${mediaQueries.tabletUp} {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${rv(10, 8)};
`;

const LogoIcon = styled.div`
  width: ${rv(32, 28)};
  height: ${rv(32, 28)};
  border-radius: ${rv(8, 6)};
  background-color: ${colors.brand[900]};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: ${rv(16, 14)};
    height: ${rv(16, 14)};
  }
`;

const LogoText = styled.span`
  font-size: ${rv(20, 16)};
  font-weight: 700;
  letter-spacing: -0.025em;
  color: ${colors.slate[900]};
`;

const CompanyInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rv(6, 4)};
  font-size: ${rv(14, 11)};
  color: ${colors.slate[500]};
  font-weight: 500;
  line-height: 1.6;

  ${mediaQueries.tabletUp} {
    text-align: right;
  }
`;

const InfoRow = styled.p`
  display: flex;
  flex-wrap: wrap;
  gap: ${rv(8, 6)};

  ${mediaQueries.tabletUp} {
    justify-content: flex-end;
  }
`;

const Divider = styled.span`
  color: ${colors.slate[300]};
  margin: 0 ${rv(8, 6)};
  display: none;

  ${mediaQueries.tabletUp} {
    display: inline;
  }
`;

const BottomBar = styled.div`
  max-width: ${containerWidth(1280, 24)};
  margin: 0 auto;
  padding-top: ${rv(32, 24)};
  margin-top: ${rv(32, 24)};
  border-top: 1px solid ${colors.slate[200]};
  display: flex;
  flex-direction: column;
  gap: ${rv(16, 12)};
  align-items: center;

  ${mediaQueries.tabletUp} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const Copyright = styled.p`
  font-size: ${rv(13, 11)};
  color: ${colors.slate[400]};
`;

const FooterLinks = styled.div`
  display: flex;
  gap: ${rv(24, 16)};
  font-size: ${rv(13, 11)};
  font-weight: 500;
`;

const FooterLink = styled.button`
  background: none;
  border: none;
  color: ${colors.slate[400]};
  cursor: pointer;
  transition: color 0.2s ease;
  font-size: inherit;
  font-weight: inherit;
  padding: 0;

  &:hover {
    color: ${colors.slate[900]};
  }
`;

const Footer: React.FC = () => {
  const [showTerms, setShowTerms] = useState(false);
  const currentYear = new Date().getFullYear();

  return (
    <>
      <FooterSection>
        <FooterContainer>
          <LogoWrapper>
            <LogoIcon>
              <LayersIcon size={16} color="white" />
            </LogoIcon>
            <LogoText>뉴럴네트워크</LogoText>
          </LogoWrapper>

          <CompanyInfo>
            <InfoRow>
              대표: 염유성
              <Divider>|</Divider>
              사업자등록번호: 633-03-03244
            </InfoRow>
            <InfoRow>
              이메일: dr0425code@gmail.com
              <Divider>|</Divider>
              전화: 010-5829-4422
            </InfoRow>
            <InfoRow>사업지: 08321 서울특별시 구로구 구로동로7나길 13-6</InfoRow>
          </CompanyInfo>
        </FooterContainer>

        <BottomBar>
          <Copyright>© {currentYear} Neural Network Inc. All rights reserved.</Copyright>
          <FooterLinks>
            <FooterLink>개인정보처리방침</FooterLink>
            <FooterLink onClick={() => setShowTerms(true)}>이용약관</FooterLink>
          </FooterLinks>
        </BottomBar>
      </FooterSection>

      <TermsModal isOpen={showTerms} onClose={() => setShowTerms(false)} />
    </>
  );
};

export default Footer;
